import React from "react";
import CircularProgress from "../../UserEngagement/EngagementView/CircularProgress";

const InstanceChart = ({ instance }) => {
  
  return (
    <div className='justify-content-between align-items-center'>
      <h6 className='mb-3'>Status</h6>
      <div className='d-flex justify-content-between w-100 mb-3'>
        <div>
          <CircularProgress
            progress={getPercentage(instance?.CompletedTasks, instance?.tasks.length)}
            strokeColor={getCompletionColor(getPercentage(instance?.CompletedTasks, instance?.tasks.length))}
            size={100}
            classProp='mr-2'
            outerText='Completed'
            strokeWidthInner={2.8}
            strokeWidth={2.8}
          />
        </div>
        <div className='mr-3'>
          <CircularProgress
            progress={getPercentage(instance?.OverDueTasks, instance?.tasks.length)}
            strokeColor={"#0099BC"}
            size={100}
            classProp='ml-2'
            outerText='Overdue'
            strokeWidthInner={2.8}
            strokeWidth={2.8}
          />
        </div>
      </div>
    </div>
  );
};

export const getPercentage = (value, total) => {
  if (!total) return 0;
  const percentage = (value / total) * 100;
  const decimalPart = percentage - Math.floor(percentage);
  return decimalPart < 0.5 ? Math.floor(percentage) : Math.ceil(percentage);
};

const getCompletionColor = (percentage) => {
  if (percentage >= 0 && percentage < 20) return "#FF746D";
  if (percentage >= 20 && percentage < 40) return "#C8DE89";
  if (percentage >= 40 && percentage < 60) return "#77AA59";
  if (percentage >= 60 && percentage < 80) return "#599646";
  if (percentage >= 80 && percentage <= 100) return "#3C8233";
  return "#0099BC"; // default color
};

export default InstanceChart;
